import { useTranslation } from "react-i18next";
import { Button } from "@nextui-org/react";
import Header from "./Header";

function UploadError({ title, desc, tryAgainFunc, imageSrc }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full h-full">
      <Header />
      <div className="flex flex-col p-5 h-full justify-between">

        {/* Top: icon + title + desc + preview */}
        <div className="flex flex-col items-center gap-5">

          {/* Error icon */}
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 9v4M12 17h.01" stroke="#ef4444" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#ef4444" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          </div>

          {/* Title + desc */}
          <div className="flex flex-col items-center text-center gap-1">
            <div className="heading text-xl">{title}</div>
            <div className="desc text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{desc}</div>
          </div>

          {/* Preview */}
          {imageSrc && (
            <div className="w-full rounded-2xl overflow-hidden bg-black">
              {imageSrc.type === "video" ? (
                <video
                  className="w-full"
                  style={{ maxHeight: "260px", objectFit: "cover" }}
                  playsInline
                  muted
                  autoPlay
                  loop
                  src={URL.createObjectURL(imageSrc.value)}
                />
              ) : (
                <img
                  className="w-full"
                  style={{ maxHeight: "260px", objectFit: "cover" }}
                  alt="Captured document"
                  src={imageSrc.value}
                />
              )}
            </div>
          )}
        </div>

        {/* CTA */}
        <Button radius="sm" color="primary" size="lg" fullWidth onClick={() => tryAgainFunc()}>
          {t("common.uploadError.tryAgain")}
        </Button>

      </div>
    </div>
  );
}

export default UploadError;
